import _ from 'lodash';
import { now } from 'helpers/DateTimeHelper';
import {
  FETCH_NEXT_PANEL_PAGE,
  FETCH_PANEL,
  SET_FIRST_PAGE,
  TOGGLE_PANEL_FETCHING,
} from './PanelActions';

const INITIAL_STATE = {
  errors: null,
  panels: {},
  fetching: false,
};

const TYPE_COLLECTION = 'Collection';
const TYPE_SEARCH_RESULT = 'SearchResult';

export default function(state = INITIAL_STATE, action) {
  const meta = _.get(action, 'meta', null);
  const updateDate = now();
  switch (action.type) {
    case FETCH_NEXT_PANEL_PAGE: {
      const data = _.get(action, 'payload.data', null);
      const panels = _.get(state, 'panels', {});
      const paginationUrl = _.get(data, 'view.next', null);
      const newPageData = _.get(data, 'member', null);
      const view = _.get(data, 'view', {});
      const panel = panels[meta.panelId];

      const panelData = _.get(panel, 'panelData', {});
      const panelType = _.get(panelData, '@type', null);
      const isCollection = panelType === TYPE_COLLECTION;
      const isSearchResult = panelType === TYPE_SEARCH_RESULT;
      const memberPath = isCollection ? 'member' : 'items.member';

      let newPaginatedItems = _.get(panelData, memberPath, []);
      if (newPageData) newPaginatedItems = newPaginatedItems.concat(newPageData);

      const newPanelData = { ...panelData };
      if (isCollection) {
        newPanelData.member = newPaginatedItems;
        newPanelData.view = view;
      } else if (isSearchResult) {
        const currentSeriesList = _.get(panelData, 'types.series.series.member', []);
        const currentSpecialsList = _.get(panelData, 'types.series.special.member', []);
        const currentMoviesList = _.get(panelData, 'types.series.movie.member', []);
        const currentEpgList = _.get(panelData, 'types.epglisting.member', []);

        const newSeriesList = _.get(data, 'types.series.series.member', []);
        const newSpecialsList = _.get(data, 'types.series.special.member', []);
        const newMoviesList = _.get(data, 'types.series.movie.member', []);
        const newEpgList = _.get(data, 'types.epglisting.member', []);

        const seriesList = currentSeriesList.concat(newSeriesList);
        const specialsList = currentSpecialsList.concat(newSpecialsList);
        const moviesList = currentMoviesList.concat(newMoviesList);
        const epgList = currentEpgList.concat(newEpgList);

        _.set(newPanelData, 'types.series.series.member', seriesList);
        _.set(newPanelData, 'types.series.special.member', specialsList);
        _.set(newPanelData, 'types.series.movie.member', moviesList);
        _.set(newPanelData, 'types.epglisting.member', epgList);

        newPanelData.items = { view };
      } else {
        const currentPaginatedItems = _.get(panelData, 'items.member', []);
        const newPaginatedItems = _.get(data, 'member', []);
        const paginatedItems = currentPaginatedItems.concat(newPaginatedItems);
        _.set(newPanelData, 'items.member', paginatedItems);
        _.set(newPanelData, 'items.view', view);
      }

      return {
        ...state,
        panels: {
          ...panels,
          [meta.panelId]: {
            lastUpdated: updateDate,
            ...panel,
            paginationUrl,
            hasMoreItems: !!paginationUrl,
            panelData: newPanelData,
          },
        },
        fetching: false,
      };
    }
    case FETCH_PANEL: {
      const data = _.get(action, 'payload.data', null);
      if (!data) return state;
      const panels = _.get(state, 'panels', {});
      const paginationUrl = _.get(data, 'view.next', null);
      return {
        ...state,
        panels: {
          ...panels,
          [meta.panelId]: {
            lastUpdated: updateDate,
            paginationUrl,
            hasMoreItems: !!paginationUrl,
            panelData: data,
          },
        },
        fetching: false,
      };
    }
    case SET_FIRST_PAGE: {
      const data = _.get(action, 'payload', null);
      const panels = _.get(state, 'panels', {});
      let paginationUrl = _.get(data, 'view.next', null);
      if (!paginationUrl) paginationUrl = _.get(data, 'items.view.next', null);
      return {
        ...state,
        panels: {
          ...panels,
          [meta.panelId]: {
            lastUpdated: updateDate,
            paginationUrl,
            hasMoreItems: !!paginationUrl,
            panelData: data,
          },
        },
      };
    }
    case TOGGLE_PANEL_FETCHING: {
      const value = _.get(action, 'payload.value', null);
      const { fetching } = state;
      return {
        ...state,
        fetching: value || !fetching,
      };
    }
    default:
      return state;
  }
}
